import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsmodal',
	templateUrl:'./BSModalPluginCompPage.html',
	styles: [],
	styleUrls:['./BSModalPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSModalPluginCompPage
{
	mdContent_837 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.modal.BSModal;
\`\`\``;
	mdContent_838 = `\`\`\`java
BSModal()
\`\`\``;
	mdContent_839 = `\`\`\`java
BSModal&lt;?&gt; modal = new BSModal&lt;&gt;();
modal.setCentered(true);
modal.setSize(BSSizes.Lg);
modal.getModalHeader().add(new H5&lt;&gt;().setText("Confirm"));
modal.getModalBody().add("Are you sure?");
modal.getModalFooter().add(new BSButton&lt;&gt;("OK").setPrimary(true));
\`\`\``;
}
